<template>
    <div class="pill page-cont">
        <div class="pill-search">
            <el-input class="search-input" placeholder="请输入查询内容" clearable v-model.trim="searchWord"  />
            <div class="textarea-btn">
                <el-button type="primary" icon="el-icon-search" @click="search_click">查询</el-button> 
            </div>
        </div>
        <div class="pill-cont" v-loading="infoLoad">
            <p class="pill-tit" v-html="infoData.title"></p>
            <div class="cont">
                <div class="cont-details">
                    <p class="basic">基本信息</p>
                    <div class="info" v-for="(item,index) in infoData.rows" :key="index">
                        <div class="info-label">{{item.label}} </div>
                        <div class="info-txt" v-html="item.text"></div>
                    </div>
                        
                </div>
                <div class="cont-atlas">
                    <div class="atlas" ref="echarts_info" v-show="echartData.length"></div>
                    <div class="atlas atlas-empty" v-show="graphLoaded && !echartData.length">暂无图谱数据</div>
                    <!-- <div class="explain">
                        <p class="tit">相关概念</p>
                        <div class="explain-info">
                            <div class="label">技术类型</div>
                            <div class="txt">药方疗法</div>
                        </div>
                        <div class="explain-info">
                            <div class="label">疾病名称</div>
                            <div class="txt">脑梗塞脑梗塞脑梗塞脑梗塞</div>
                        </div>
                        <div class="explain-info">
                            <div class="label">治法</div>
                            <div class="txt">活血$化瘀$祛邪</div>
                        </div>
                    </div> -->
                </div>
            </div>
         </div>
    </div>
</template>

<script>
import {globalInfo,pillGetGraph} from '../io/api.js'
export default {
    data () {
        return {
            searchWord:this.$route.query.word||'',
            flag:this.$route.query.flag||'',
            echartsInfo:'',
            infoLoad:false,
            infoData:{ },
            echartData:[],
            graphLoaded:false,
            globalRow:{},
        }
    },
    created () {
        //从localStorage取出入参
        const globalRowStr = window.localStorage.getItem('globalRow');
        this.globalRow = globalRowStr ? JSON.parse(globalRowStr) : {};
    },
    mounted () {
        this.$nextTick(()=>{
            this.getInfo();
        })
    },
    methods: {
        getDetailParams(){
            return {
                id: this.globalRow.Tid||'',
                link: this.globalRow.link||'',
                table: this.globalRow.table||'',
                searchWord:this.searchWord,//this.globalRow.chi_str_row||'',
                flag:this.flag,
            }
        },
        // title 可能含 HTML，图谱入参只用纯文本
        // getPlainTitle(title){
        //     if(!title) return '';
        //     const div = document.createElement('div');
        //     div.innerHTML = title;
        //     return (div.textContent || div.innerText || '').trim();
        // },
        getInfo(){ 
            this.infoLoad=true;
            globalInfo(this.getDetailParams()).then(res=>{
                let{code,data,msg}=res.data;
                if(code==0){
                    this.infoData=data||{};
                    // 详情成功后再拉图谱，name 用 title
                    this.getGraph(this.infoData.title);
                }else{
                    this.$message.error(msg||'请求失败～')
                    this.graphLoaded = true;
                }
                this.infoLoad=false;
            }).catch(()=>{
                this.infoLoad=false;
                this.graphLoaded = true;
            })
        },
        getGraph(name){
            let params = { 
                name: name || '',
                limit:10,
            }
            pillGetGraph(params).then(res=>{
                const { code, data, msg } = res.data || {};
                const list = Array.isArray(data && data.data) ? data.data
                    : (Array.isArray(data) ? data : []);
                if(code==0){
                    this.echartData = list;
                    this.graphLoaded = true;
                    if(list.length){
                        this.$nextTick(()=>{
                            this.getEchart();
                        })
                    }else if(this.echartsInfo){
                        this.echartsInfo.clear();
                    }
                }else{
                    this.echartData = [];
                    this.graphLoaded = true;
                    this.$message.error(msg||'图谱请求失败～')
                }
            }).catch(()=>{
                this.echartData = [];
                this.graphLoaded = true;
            })
        },
        search_click(word){
            let query={
                word:this.searchWord,
            };
            // let url= this.$router.resolve({
            this.$router.push({
                path:'globalHotWord',
                query,
            }) 
            // this.$windowOpen({ url:url.href,isLogin:false} )
        },
        initChart(){
            if(!this.$refs.echarts_info) return;
            if(this.echartsInfo){
                this.echartsInfo.resize();
                return;
            }
            this.echartsInfo = this.$echarts.init(this.$refs.echarts_info);
        },
        getEchart(){ 
            if(!this.echartData.length) return;
            this.initChart();
            if(!this.echartsInfo) return;

            const startName = this.echartData[0].start_name || this.infoData.title || this.searchWord || '';
            const nodeMap = new Map();
            nodeMap.set(startName, {
                id: startName,
                name: startName,
                category: 0,
                symbolSize:50,
                itemStyle: { color: '#E6A23C ' },
            });
            const links = [];
            this.echartData.forEach((rows)=>{
                const endName = rows.end_name;
                if(!nodeMap.has(endName)){
                    nodeMap.set(endName, {
                        id: endName,
                        name: endName,
                        category: 1,
                        symbolSize: 36,
                        itemStyle: { color: '#409EFF' },
                    });
                }
                links.push({
                    source: startName,
                    target: endName,
                    relation: rows.relation,
                    label: {
                        show: false,
                    },
                });
            });

            const option = {
                title: {
                    text: '知识图谱',
                    left: 'left',
                    top: 0,
                    textStyle: {
                        color: '#333',
                        fontSize: 14,
                    },
                },
                tooltip: {
                    trigger: 'item',
                    formatter(params) {
                        if (params.dataType === 'edge') {
                            return params.data.relation || `${params.data.source} → ${params.data.target}`;
                        }
                        return params.name || '';
                    },
                },
                series: [{
                    type: 'graph',
                    layout: 'force',
                    roam: true,
                    draggable: true,
                    categories: [{ name: '中心' }, { name: '关联' }],
                    data: Array.from(nodeMap.values()),
                    links,
                    label: {
                        show: true,
                        position: 'inside',
                        color: '#333',
                        fontSize: 12,
                    },
                    lineStyle: {
                        color: '#94A3B8',
                        width: 1,
                        curveness: 0.15,
                        opacity: 0.7,
                    },
                    emphasis: {
                        focus: 'adjacency',
                        scale: 1.08,
                    },
                    force: {
                        // 容器仅 260px，斥力过大节点会飞出视野
                        repulsion: 120,
                        edgeLength: [70, 100],
                        gravity: 0.2, 
                    },
                }],
            };
            this.echartsInfo.setOption(option, true);
            this.$nextTick(()=>{
                this.echartsInfo && this.echartsInfo.resize();
            });
        }
        
    }
}
</script>
<style lang="less">
.pill .info-txt a{
    height: auto!important;
}
</style>
<style lang="less" scoped>
.pill{ 
    // padding:20px;
    .flex-space-between{
        display: flex;
        justify-content: space-between;
    }
    .pill-search{
        display: flex;
        justify-content: center;
        margin-bottom:20px;
        .search-input{
            width: 800px;
            margin-right:20px;
        }
    } 
    .pill-cont{  
        .pill-tit{
            font-weight: bold;
            margin-bottom: 10px;
            font-size: 24px;
        }
        .cont{
            .flex-space-between();
            line-height: 28px; 
            .cont-details{
                // flex-grow: 1;
                width:910px;
                border: 1px solid #dadada;
                border-bottom:none;
            }
            .cont-atlas{
                width:260px;
                .atlas,.explain{
                    width: 260px;
                    border: 1px solid #dadada; 
                }
                .atlas{
                    height: 260px;
                    margin-bottom: 20px;
                }
                .atlas-empty{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #909399;
                    font-size: 14px;
                    background: #fafafa;
                }
                .explain{
                    background: #efefef;
                    padding:8px;
                    .tit{
                        font-weight: bold;
                    }
                    .explain-info{
                        .flex-space-between();
                        padding: 8px 0;
                        line-height: 20px;
                        border-top: 1px solid #dddddd;
                        .label{
                            width: 70px;
                        }
                        .txt{
                            width: 160px;
                        }
                    }
                } 
            }
        }
        .basic{
            background: #efefef;
            padding:0 10px;
            border-bottom: 1px solid #dadada;
            min-height: 28px; 
            padding:6px 10px;
            font-size: 16px;
            font-weight: bold
        }
        .info{
            .flex-space-between();
            padding:6px 10px;
            border-bottom: 1px solid #dadada;
            min-height: 28px; 
            .info-label{
                width: 150px;
                flex-shrink: 0;
                font-weight: bold
            }
            .info-txt{
                width: 1030px;//720px; 
                
            }
        }
    }
}
</style>
